/**
 * Helper para normalizar URLs da API e evitar barras duplas
 */
import { getApiBaseUrl } from '@/config/production';

/**
 * Obtém a URL base da API normalizada (sem barras finais)
 */
export const getNormalizedApiBase = (): string => {
  const base = getApiBaseUrl();
  // Remove todas as barras finais para evitar barras duplas
  return base.replace(/\/+$/, '');
};

/**
 * Constrói uma URL completa da API garantindo que não há barras duplas
 * @param endpoint - Endpoint da API (com ou sem barra inicial)
 * @returns URL completa normalizada
 */
export const buildApiUrl = (endpoint: string): string => {
  const base = getNormalizedApiBase();
  // Garantir que o endpoint começa com /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${base}${normalizedEndpoint}`;
};

